module.exports = __webpack_public_path__ + "img/proiecte.369f6d83.svg";